import React from 'react'
import type { RangePickerProps } from 'antd/es/date-picker'
import DatePicker from 'antd/es/date-picker'
import { getRangePresets } from '../../utils/time.ts'
import dayjs from 'dayjs'

const { RangePicker } = DatePicker

interface IdeyaRangePickerProps
  extends React.ComponentProps<typeof RangePicker> {
  disableHistoricalDates?: boolean
}

const IdeyaRangePicker: React.FC<IdeyaRangePickerProps> = ({
  disableHistoricalDates,
  ...props
}) => {
  const rangePresets: RangePickerProps['presets'] = getRangePresets()

  const disabledDate = disableHistoricalDates
    ? (current: dayjs.Dayjs) => current && current < dayjs().startOf('day')
    : props.disabledDate

  return (
    <RangePicker
      allowClear={false}
      presets={rangePresets}
      disabledDate={disabledDate}
      {...props}
    />
  )
}

export default IdeyaRangePicker
